import { ThemeSpec } from '../parsing/FilterTypesSpec';
import { generateId } from './idgen';
import yaml from 'yaml';
export var toThemeStructuredComment = function (name, config, subtitle, description) {
    var theme = ThemeSpec.parse({
        name: name,
        subtitle: subtitle,
        description: description,
        config: {
            enabledModules: config.enabledModules,
            inputConfigs: config.inputConfigs,
        },
    });
    return "/*@ define:theme:".concat(generateId(), "\n").concat(yaml.stringify(theme), "*/\n");
};
